import { PDFDocument, StandardFonts, rgb, PDFRawStream } from 'pdf-lib';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
// import fontkit from '@pdf-lib/fontkit'; // Şimdilik kapalı

/**
 * PDF oluşturma ana fonksiyonu - Android PdfManager.kt'yi taklit eder
 */
/**
 * Puantaj verisini tamamen temizleyen fonksiyon
 */
const cleanPuantajData = (puantajData) => {
  const cleanedData = {};
  
  Object.keys(puantajData).forEach(key => {
    const value = puantajData[key];
    if (typeof value === 'string') {
      cleanedData[key] = cleanTurkishText(value);
    } else {
      cleanedData[key] = value;
    }
  });
  
  return cleanedData;
};

/**
 * Kullanıcı bilgilerini temizleyen fonksiyon
 */
const cleanUserInfo = (userInfo) => {
  const cleanedInfo = {};
  
  Object.keys(userInfo).forEach(key => {
    const value = userInfo[key];
    if (typeof value === 'string') {
      cleanedInfo[key] = cleanTurkishText(value);
    } else {
      cleanedInfo[key] = value;
    }
  });
  
  return cleanedInfo;
};

export const createPuantajPDF = async (puantajData, userInfo, showPuantajPrice = false) => {
  try {
    console.log('📄 PDF oluşturma başladı - Yeni tasarım:', {
      'Müşteri': puantajData['Müşteri Adı'],
      'Makine': puantajData['Makine İsmi'],
      'Tarih': puantajData['Tarih']
    });
    
    // VERİLERİ TEMİZLE (PDF uyumluluğu için)
    const cleanedPuantajData = cleanPuantajData(puantajData);
    const cleanedUserInfo = cleanUserInfo(userInfo);
    
    console.log('✨ Türkçe karakterler PDF için temizlendi:', {
      'Orijinal Müşteri': puantajData['Müşteri Adı'],
      'Temizlenmiş Müşteri': cleanedPuantajData['Müşteri Adı'],
      'Orijinal Operatör': puantajData['Operatör Adı'],
      'Temizlenmiş Operatör': cleanedPuantajData['Operatör Adı']
    });
    
    // PDF dokümanı oluştur
    const pdfDoc = await PDFDocument.create();
    
    // Sayfa boyutları - A4 formatı (210x297mm)
    const page = pdfDoc.addPage([595, 842]); // A4 portrait
    const { width, height } = page.getSize();
    
    // Standart fontları kullan 
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    
    console.log('Standart fontlar yüklendi - veriler önceden temizlendi');
    
    // Logo ekleme (eğer varsa)
    let logoImage = null;
    try {
      // Logo URL'si varsa yükle
      if (userInfo.logoUrl) {
        console.log('🖼️ Logo yükleniyor:', userInfo.logoUrl);
        const response = await fetch(userInfo.logoUrl);
        
        // Response başarılı mı kontrol et
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        
        const logoImageBytes = await response.arrayBuffer();
        
        // Content-Type'a göre format belirle
        const contentType = response.headers.get('content-type');
        console.log('📋 Logo Content-Type:', contentType);
        
        if (contentType && (contentType.includes('jpeg') || contentType.includes('jpg'))) {
          logoImage = await pdfDoc.embedJpg(logoImageBytes);
          console.log('📷 JPEG logo embed edildi');
        } else if (contentType && contentType.includes('png')) {
          logoImage = await pdfDoc.embedPng(logoImageBytes);
          console.log('📷 PNG logo embed edildi');
        } else {
          // Content-Type belirsizse, önce PNG dene, sonra JPEG
          try {
            logoImage = await pdfDoc.embedPng(logoImageBytes);
            console.log('📷 PNG logo embed edildi (varsayılan)');
          } catch (pngError) {
            console.log('PNG embed başarısız, JPEG deneniyor...');
            logoImage = await pdfDoc.embedJpg(logoImageBytes);
            console.log('📷 JPEG logo embed edildi (fallback)');
          }
        }
      }
    } catch (error) {
      console.warn('⚠️ Logo yüklenemedi:', error.message);
      console.warn('🔧 Logo URL\'ini ve Firebase Storage kurallarını kontrol edin');
    }
    
    // PDF içeriği oluştur (temizlenmiş verilerle)
    const result = await createPDFContent(page, {
      font,
      boldFont,
      logoImage,
      puantajData: cleanedPuantajData,
      userInfo: cleanedUserInfo,
      width,
      height,
      showPuantajPrice
    });
    
    // PDF'i byte array olarak döndür
    const pdfBytes = await pdfDoc.save();
    return { pdfBytes, yetkiliImzasiYPosition: result.yetkiliImzasiYPosition };
    
  } catch (error) {
    console.error('PDF oluşturma hatası:', error);
    throw new Error('PDF oluşturulurken bir hata oluştu: ' + error.message);
  }
};

// İmza pozisyonları için global değişkenler
let yetkiliImzasiYPosition = null;
let operatorImzasiYPosition = null;
let firmaYetkilisiImzasiYPosition = null;

// Türkçe karakter dönüştürme fonksiyonunu güncelle
const turkishToAscii = (text) => {
  if (!text) return '';
  if (typeof text !== 'string') return String(text);
  
  const charMap = {
    'ğ': 'g', 'Ğ': 'G',
    'ü': 'u', 'Ü': 'U',
    'ş': 's', 'Ş': 'S',
    'ı': 'i', 'İ': 'I',
    'ö': 'o', 'Ö': 'O',
    'ç': 'c', 'Ç': 'C',
    'â': 'a', 'Â': 'A',
    'î': 'i', 'Î': 'I',
    'û': 'u', 'Û': 'U'
  };

  return text.replace(/[ğĞüÜşŞıİöÖçÇâÂîÎûÛ]/g, match => charMap[match] || match);
};

// Başlık metinlerini ASCII'ye dönüştür
const TITLES = {
  MAIN: 'PUANTAJ FORMU',
  FIRMA: 'FIRMA BILGILERI',
  MAKINE: 'MAKINE BILGILERI',
  CALISMA: 'CALISMA BILGILERI',
  IMZA: 'YETKILI IMZASI'
};

const LABELS = {
  firma: {
    ad: 'Firma Adi:',
    adres: 'Adres:',
    telefon: 'Telefon:'
  },
  makine: {
    no: 'Sozlesme No:',
    tur: 'Makine Turu:',
    tarih: 'Tarih:',
    operator: 'Operator:'
  },
  calisma: {
    musteri: 'Musteri Adi:',
    yetkili: 'Yetkili Kisi:',
    aciklama: 'Aciklama:',
    baslangic1: '1. Baslangic Saati:',
    bitis1: '1. Bitis Saati:',
    baslangic2: '2. Baslangic Saati:',
    bitis2: '2. Bitis Saati:',
    baslangic3: '3. Baslangic Saati:',
    bitis3: '3. Bitis Saati:',
    toplam: 'Toplam Sure:'
  }
};

// Güvenli veri alma yardımcı fonksiyonu
const safeGet = (obj, path, defaultValue = '') => {
  if (!obj || !path) return defaultValue;
  return path.split('.').reduce((acc, part) => (acc && acc[part] ? acc[part] : defaultValue), obj);
};

// Çoklu anahtar kontrolü için genel amaçlı yardımcı
const pickFirst = (obj, keys, defaultValue = '') => {
  for (const key of keys) {
    if (obj && Object.prototype.hasOwnProperty.call(obj, key) && obj[key]) {
      return obj[key];
    }
  }
  return defaultValue;
};

const createPDFContent = async (page, {
  font,
  boldFont,
  logoImage,
  puantajData = {},
  userInfo = {},
  width,
  height,
  showPuantajPrice = false
}) => {
  // Renk tanımlamaları
  const primaryColor = rgb(0, 0, 0);  // Siyah
  const backgroundColor = rgb(0.98, 0.98, 0.98); // Açık gri
  const borderColor = rgb(0.6, 0.6, 0.6); // Koyu gri çizgiler
  const headerBackgroundColor = rgb(0.92, 0.92, 0.92); // Başlık gri arka plan
  const tableBackgroundColor = rgb(0.97, 0.97, 0.97); // Tablo gri arka plan

  // Sayfa kenar boşlukları
  const leftMargin = 40;
  const rightMargin = width - 40;
  const topMargin = height - 40;
  
  // Başlık - HopsPlus ile aynı boyut (20pt) - padding'i azalt
  const titleWidth = font.widthOfTextAtSize(TITLES.MAIN, 20);
  const titleX = (width - titleWidth) / 2;
  page.drawText(TITLES.MAIN, {
    x: titleX,
    y: topMargin - 10, // 20'den 10'a düşürüldü
    size: 20,
    font: boldFont,
    color: primaryColor
  });

  let yPosition = topMargin - 40; // 60'tan 40'a düşürüldü

  // Firma Bilgileri Bölümü - dinamik yükseklik hesaplama
  const firmaAdHeightCalc = calculateTextHeight(turkishToAscii(pickFirst(userInfo, ['firmaAdi', 'companyName', 'Firma Adı'])), font, 300);
  const firmaAdresHeightCalc = calculateTextHeight(turkishToAscii(pickFirst(userInfo, ['adres', 'companyAddress', 'Adres'])), font, 300);
  const firmaTelefonHeightCalc = calculateTextHeight(pickFirst(userInfo, ['telefon', 'companyPhone', 'Telefon']), font, 300);
  
  const firmaContentHeight = Math.max(100, 40 + firmaAdHeightCalc + firmaAdresHeightCalc + firmaTelefonHeightCalc + 20); // En az 100px
  
  // Ana çerçeve (beyaz arka plan - HopsPlus formatı)
  page.drawRectangle({
    x: leftMargin,
    y: yPosition - firmaContentHeight,
    width: width - (leftMargin * 2),
    height: firmaContentHeight,
    borderColor: rgb(0.7, 0.7, 0.7), // Grimsi çerçeve
    color: rgb(1, 1, 1), // Beyaz arka plan
    borderWidth: 1 // Çerçeve çizgisi
  });

  // Başlık gri alanı (HopsPlus formatı)
  page.drawRectangle({
    x: leftMargin,
    y: yPosition - 25,
    width: width - (leftMargin * 2),
    height: 25,
    borderColor: rgb(0.7, 0.7, 0.7), // Grimsi çerçeve
    color: headerBackgroundColor,
    borderWidth: 1 // Çerçeve çizgisi
  });

  // Firma Bilgileri Başlığı - HopsPlus ile aynı boyut (14pt)
  page.drawText(TITLES.FIRMA, {
    x: leftMargin + 10,
    y: yPosition - 20,
    size: 14,
    font: boldFont,
    color: primaryColor
  });

  // Dikey çizgi kaldırıldı - sadece renk farkı

  // Firma detayları - responsive yapı
  const drawFirmaDetail = (label, value, offsetY, drawSeparator = true) => {
    const maxValueWidth = 300; // Value için maksimum genişlik
    
    // Label her zaman tek satır - HopsPlus ile aynı boyut (14pt)
    page.drawText(turkishToAscii(label), {
      x: leftMargin + 10,
      y: yPosition - offsetY,
      size: 14,
      font: boldFont,
      color: primaryColor
    });
    
    // Value responsive çizim
    const valueHeight = drawResponsiveText(
      page,
      turkishToAscii(value),
      leftMargin + 120,
      yPosition - offsetY,
      maxValueWidth,
      font,
      primaryColor
    );
    
    return valueHeight;
  };

  // Firma detayları - dinamik pozisyonlama
  let firmaOffset = 40;
  
  const firmaAdHeight = drawFirmaDetail(LABELS.firma.ad, turkishToAscii(pickFirst(userInfo, ['firmaAdi', 'companyName', 'Firma Adı'])), firmaOffset, false);
  firmaOffset += firmaAdHeight + 5;
  
  // Adres satırı - diğer değerlerle aynı hizada
  const firmaAdresHeight = drawFirmaDetail(LABELS.firma.adres, turkishToAscii(pickFirst(userInfo, ['adres', 'companyAddress', 'Adres'])), firmaOffset);
  firmaOffset += firmaAdresHeight + 5;
  
  const firmaTelefonHeight = drawFirmaDetail(LABELS.firma.telefon, pickFirst(userInfo, ['telefon', 'companyPhone', 'Telefon']), firmaOffset);
  firmaOffset += firmaTelefonHeight + 5;

  // Logo - daha aşağı kaydırıldı
  if (logoImage) {
    const logoSize = 70;
    page.drawImage(logoImage, {
      x: width - leftMargin - logoSize - 10,
      y: yPosition - 110, // 90'dan 110'a düşürüldü
      width: logoSize,
      height: logoSize
    });
  }

  // Makine Bilgileri Bölümü
  yPosition -= (firmaContentHeight + 10); // Dinamik boşluk - azaltıldı
  
  // Makine bilgileri için dinamik yükseklik hesaplama
  const makineNoHeightCalc = calculateTextHeight(pickFirst(puantajData, ['Sozlesme No', 'Sözleşme No', 'contractNumber', 'Makine İsmi', 'machineId']), font, 300);
  const makineTurHeightCalc = calculateTextHeight(pickFirst(puantajData, ['Makine Türü', 'Makine Turu', 'machineType'], 'Teleskopik Yukleyici'), font, 300);
  const makineTarihHeightCalc = calculateTextHeight(pickFirst(puantajData, ['Tarih', 'date']), font, 300);
  const makineOperatorHeightCalc = calculateTextHeight(turkishToAscii(pickFirst(puantajData, ['Operatör Adı', 'operatorName', 'Operator'])), font, 300);
  
  const makineContentHeight = Math.max(100, 40 + makineNoHeightCalc + makineTurHeightCalc + makineTarihHeightCalc + makineOperatorHeightCalc + 20); // En az 100px
  
  // Ana çerçeve (beyaz arka plan - HopsPlus formatı)
  page.drawRectangle({
    x: leftMargin,
    y: yPosition - makineContentHeight,
    width: width - (leftMargin * 2),
    height: makineContentHeight,
    borderColor: rgb(0.7, 0.7, 0.7), // Grimsi çerçeve
    color: rgb(1, 1, 1), // Beyaz arka plan
    borderWidth: 1 // Çerçeve çizgisi
  });

  // Başlık gri alanı (HopsPlus formatı)
  page.drawRectangle({
    x: leftMargin,
    y: yPosition - 25,
    width: width - (leftMargin * 2),
    height: 25,
    borderColor: rgb(0.7, 0.7, 0.7), // Grimsi çerçeve
    color: headerBackgroundColor,
    borderWidth: 1 // Çerçeve çizgisi
  });

  page.drawText(TITLES.MAKINE, {
    x: leftMargin + 10,
    y: yPosition - 20,
    size: 14,
    font: boldFont,
    color: primaryColor
  });

  // Dikey çizgi kaldırıldı - sadece renk farkı

  const drawMakineDetail = (label, value, offsetY, drawSeparator = true) => {
    const maxValueWidth = 300; // Value için maksimum genişlik
    
    // Label her zaman tek satır - HopsPlus ile aynı boyut (14pt)
    page.drawText(turkishToAscii(label), {
      x: leftMargin + 10,
      y: yPosition - offsetY,
      size: 14,
      font: boldFont,
      color: primaryColor
    });
    
    // Value responsive çizim
    const valueHeight = drawResponsiveText(
      page,
      turkishToAscii(value),
      leftMargin + 120,
      yPosition - offsetY,
      maxValueWidth,
      font,
      primaryColor
    );
    
    return valueHeight;
  };

  // Makine bilgileri - dinamik pozisyonlama
  let makineOffset = 40;
  
  // Sözleşme numarasını doğru şekilde oluştur: Makine İsmi + Puantaj Sayısı
  const machineCode = puantajData['Makine İsmi'] || 'makine';
  const puantajNumber = puantajData['Puantaj Sayısı'] || 'puantaj';
  const contractNumber = `${machineCode}-${puantajNumber}`;
  
  const makineNoHeight = drawMakineDetail(LABELS.makine.no, pickFirst(puantajData, ['Sozlesme No', 'Sözleşme No', 'contractNumber']) || contractNumber, makineOffset, false);
  makineOffset += makineNoHeight + 5;
  
  const makineTurHeight = drawMakineDetail(LABELS.makine.tur, pickFirst(puantajData, ['Makine Türü', 'Makine Turu', 'machineType'], 'Teleskopik Yukleyici'), makineOffset);
  makineOffset += makineTurHeight + 5;
  
  const makineTarihHeight = drawMakineDetail(LABELS.makine.tarih, pickFirst(puantajData, ['Tarih', 'date']), makineOffset);
  makineOffset += makineTarihHeight + 5;
  
  const makineOperatorHeight = drawMakineDetail(LABELS.makine.operator, turkishToAscii(pickFirst(puantajData, ['Operatör Adı', 'operatorName', 'Operator'])), makineOffset);
  makineOffset += makineOperatorHeight + 5;

  // Çalışma Bilgileri Bölümü
  yPosition -= (makineContentHeight + 10); // Dinamik boşluk - azaltıldı
  
  // 3. saat bilgilerini önce kontrol et
  const startTime3 = pickFirst(puantajData, ['startTime3', '3. Başlangıç Saati', '3. Baslangic Saati']);
  const endTime3 = pickFirst(puantajData, ['endTime3', '3. Bitiş Saati', '3. Bitis Saati']);
  
  // Dinamik yükseklik hesaplama - responsive içerik için
  const hasThirdShift = (startTime3 && startTime3.trim() !== '') || (endTime3 && endTime3.trim() !== '');
  
  // İçerik yüksekliğini tahmin et (responsive metinler için)
  const customerNameHeight = calculateTextHeight(turkishToAscii(pickFirst(puantajData, ['Müşteri Adı', 'customerName', 'customer'])), font, 300);
  const authorizedPersonHeight = calculateTextHeight(turkishToAscii(pickFirst(puantajData, ['Yetkili Adı', 'authorizedPerson', 'YetkiliAdi', 'yetkiliAdi'], '-')), font, 300);
  const workDetailHeight = calculateTextHeight(turkishToAscii(safeGet(puantajData, 'workDetail', 'Standart calisma yapilmistir.')), font, 300);
  
  // 2. saat bilgilerini kontrol et (yükseklik hesaplama için)
  const startTime2ForHeight = pickFirst(puantajData, ['startTime2', '2. Başlangıç Saati', '2. Baslangic Saati']);
  const endTime2ForHeight = pickFirst(puantajData, ['endTime2', '2. Bitiş Saati', '2. Bitis Saati']);
  const hasSecondShiftForHeight = (startTime2ForHeight && startTime2ForHeight.trim() !== '') || (endTime2ForHeight && endTime2ForHeight.trim() !== '');
  
  // Temel yükseklik + responsive metinler + saat alanları
  const baseTimeFields = hasSecondShiftForHeight ? 4 : 2; // 2. saat varsa 4 alan, yoksa 2 alan
  const baseHeight = 40 + customerNameHeight + authorizedPersonHeight + workDetailHeight + (baseTimeFields * 30) + 30; // Dinamik saat alanı + padding (14pt font için)
  const thirdShiftHeight = hasThirdShift ? 50 : 0; // 3. saat için ek alan
  const totalTimeRowHeight = 30; // Toplam süre satırı için ek alan
  const contentHeight = Math.max(210, baseHeight + thirdShiftHeight + totalTimeRowHeight); // En az 210px + toplam süre satırı
  
  // Ana çerçeve (gri arka plan - HopsPlus gibi)
  page.drawRectangle({
    x: leftMargin,
    y: yPosition - contentHeight,
    width: width - (leftMargin * 2),
    height: contentHeight,
    borderColor,
    color: headerBackgroundColor, // Gri arka plan
    borderWidth: 1.5
  });

  // Başlık gri alanı
  page.drawRectangle({
    x: leftMargin,
    y: yPosition - 25,
    width: width - (leftMargin * 2),
    height: 25,
    borderColor,
    color: headerBackgroundColor,
    borderWidth: 1
  });

  page.drawText(TITLES.CALISMA, {
    x: leftMargin + 10,
    y: yPosition - 20,
    size: 14,
    font: boldFont,
    color: primaryColor
  });

  // Dikey çizgi kaldırıldı - HopsPlus'ta yok

  const drawCalismaDetail = (label, value, offsetY, drawSeparator = true) => {
    const maxValueWidth = 300; // Value için maksimum genişlik
    
    // Value yüksekliğini hesapla
    const valueHeight = calculateTextHeight(turkishToAscii(value), font, maxValueWidth);
    const actualRowHeight = Math.max(25, valueHeight + 5); // En az 25px (14pt font için), ama metin yüksekliği + padding
    
    // Satır arası çizgi (ilk satır hariç) - responsive yükseklik ile
    if (drawSeparator && offsetY > 40) {
      page.drawLine({
        start: { x: leftMargin + 5, y: yPosition - offsetY + actualRowHeight },
        end: { x: width - leftMargin - 5, y: yPosition - offsetY + actualRowHeight },
        thickness: 0.5,
        color: rgb(0.8, 0.8, 0.8) // Grimsi renk
      });
    }
    
    // Label her zaman tek satır - HopsPlus ile aynı boyut (14pt)
    page.drawText(turkishToAscii(label), {
      x: leftMargin + 10,
      y: yPosition - offsetY,
      size: 14,
      font: boldFont,
      color: primaryColor
    });
    
    // Value responsive çizim
    drawResponsiveText(
      page,
      turkishToAscii(value),
      leftMargin + 160,
      yPosition - offsetY,
      maxValueWidth,
      font,
      primaryColor
    );
    
    return actualRowHeight;
  };

  // Dinamik pozisyonlama için offset takibi
  let currentOffset = 40;
  
  // Müşteri adı - responsive
  const customerName = pickFirst(puantajData, ['Müşteri Adı', 'customerName', 'customer']);
  console.log('🎯 PDF\'te kullanılan müşteri adı:', {
    'Bulunan değer': customerName,
    'puantajData keys': Object.keys(puantajData),
    'Müşteri Adı field': puantajData['Müşteri Adı'],
    'customerName field': puantajData['customerName']
  });
  const customerHeight = drawCalismaDetail(LABELS.calisma.musteri, turkishToAscii(customerName), currentOffset, false);
  currentOffset += customerHeight + 5;
  
  // Yetkili kişi - responsive
  const authorizedPerson = pickFirst(puantajData, ['Yetkili Adı', 'authorizedPerson', 'YetkiliAdi', 'yetkiliAdi'], '-');
  const authorizedHeight = drawCalismaDetail(LABELS.calisma.yetkili, turkishToAscii(authorizedPerson), currentOffset);
  currentOffset += authorizedHeight + 5;
  
  // Açıklama - responsive
  const workDescription = pickFirst(puantajData, ['Çalışma Detayı', 'workDetail', 'CalismaDetayi', 'calismaDetayi', 'description', 'aciklama', 'detay'], 'Standart calisma yapilmistir.');
  const descriptionHeight = drawCalismaDetail(LABELS.calisma.aciklama, turkishToAscii(workDescription), currentOffset);
  currentOffset += descriptionHeight + 5;
  
  // 2. saat bilgilerini kontrol et
  const startTime2 = pickFirst(puantajData, ['startTime2', '2. Başlangıç Saati', '2. Baslangic Saati']);
  const endTime2 = pickFirst(puantajData, ['endTime2', '2. Bitiş Saati', '2. Bitis Saati']);
  const hasSecondShift = (startTime2 && startTime2.trim() !== '') || (endTime2 && endTime2.trim() !== '');
  
  // Koşullu label'lar - 2. saat varsa "1.", yoksa sadece "Başlangıç/Bitiş"
  const startLabel = hasSecondShift ? LABELS.calisma.baslangic1 : "Başlangıç Saati:";
  const endLabel = hasSecondShift ? LABELS.calisma.bitis1 : "Bitiş Saati:";
  
  // Saat alanlarını çoklu anahtar desteğiyle al
  const startTime1Height = drawCalismaDetail(
    startLabel,
    pickFirst(puantajData, ['startTime1', '1. Başlangıç Saati', '1. Baslangic Saati']),
    currentOffset
  );
  currentOffset += startTime1Height + 5;
  
  const endTime1Height = drawCalismaDetail(
    endLabel,
    pickFirst(puantajData, ['endTime1', '1. Bitiş Saati', '1. Bitis Saati']),
    currentOffset
  );
  currentOffset += endTime1Height + 5;
  
  // 2. saat bilgilerini sadece veri varsa yaz
  if (hasSecondShift) {
    const startTime2Height = drawCalismaDetail(
      LABELS.calisma.baslangic2,
      startTime2,
      currentOffset
    );
    currentOffset += startTime2Height + 5;
    
    const endTime2Height = drawCalismaDetail(
      LABELS.calisma.bitis2,
      endTime2,
      currentOffset
    );
    currentOffset += endTime2Height + 5;
  }
  
  // 3. saat bilgilerini sadece veri varsa yaz
  if (startTime3 && startTime3.trim() !== '') {
    const startTime3Height = drawCalismaDetail(
      LABELS.calisma.baslangic3,
      startTime3,
      currentOffset
    );
    currentOffset += startTime3Height + 5;
  }
  
  if (endTime3 && endTime3.trim() !== '') {
    const endTime3Height = drawCalismaDetail(
      LABELS.calisma.bitis3,
      endTime3,
      currentOffset
    );
    currentOffset += endTime3Height + 5;
  }
  
  // Toplam çalışma süresini hesapla ve dinamik pozisyona yerleştir
  const totalWorkingTime = calculateTotalWorkingTime(puantajData);
  
  // Fiyat bilgisini toplam sürenin yanına ekle (eğer aktifse)
  let totalTimeText = totalWorkingTime;
  if (showPuantajPrice) {
    try {
      const calculatedPrice = await calculatePuantajPriceForPDF(puantajData);
      if (calculatedPrice) {
        // Toplam süreyi "8:30" formatından "8 saat 30 dakika" formatına çevir
        const formattedTime = formatTimeToReadable(totalWorkingTime);
        totalTimeText = `${formattedTime} // ${calculatedPrice}`;
        console.log('✅ PDF fiyat eklendi:', totalTimeText);
      }
    } catch (error) {
      console.error('PDF fiyat hesaplama hatası:', error);
    }
  }
  
  const totalTimeHeight = drawCalismaDetail(LABELS.calisma.toplam, totalTimeText, currentOffset);
  currentOffset += totalTimeHeight + 10; // Toplam süre satırı sonrası boşluk

  // İmza Bölümü - toplam süre satırından sonra konumlandır
  yPosition -= (currentOffset + 20); // Dinamik pozisyon - toplam süre sonrası
  page.drawText(TITLES.IMZA, {
    x: leftMargin + 10,
    y: yPosition,
    size: 12,
    font: boldFont,
    color: primaryColor
  });

  // Alt bilgi - HopsPlus formatında mavi renk (orta)
  const currentDate = new Date();
  const dateFormatter = new Intl.DateTimeFormat('tr-TR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
  const formattedDateTime = dateFormatter.format(currentDate);
  
  const footerText = `Bu belge HOPS sistemi tarafindan ${formattedDateTime} tarihinde elektronik olarak olusturulmustur.`;
  const footerTextWidth = font.widthOfTextAtSize(footerText, 12);
  const footerX = (width - footerTextWidth) / 2; // Ortalanmış
  
  page.drawText(footerText, {
    x: footerX,
    y: 15, // HopsPlus gibi daha aşağıya
    size: 12, // HopsPlus ile aynı boyut
    font: font,
    color: rgb(0.2, 0.4, 0.8) // HopsPlus'taki mavi renk
  });

  // İmza pozisyonlarını kaydet - yazının hemen altında olacak şekilde
  yetkiliImzasiYPosition = yPosition; // Yazının Y pozisyonu
  operatorImzasiYPosition = yPosition;
  firmaYetkilisiImzasiYPosition = yPosition;

  return {
    operatorImzasiYPosition,
    yetkiliImzasiYPosition,
    firmaYetkilisiImzasiYPosition
  };
};

/**
 * Metin çizme fonksiyonu (veriler önceden temizlenmiş)
 */
const drawTextSafely = (page, text, options) => {
  try {
    page.drawText(text || '', options);
  } catch (error) {
    // Son çare olarak tekrar temizle
    console.warn('⚠️ Beklenmeyen karakter hatası, tekrar temizleniyor:', error.message);
    const cleanText = cleanTurkishText(text || '');
    page.drawText(cleanText, options);
  }
};

/**
 * Türkçe karakterleri temizleme fonksiyonu (PDF için optimize edilmiş)
 */
const cleanTurkishText = (text) => {
  if (!text) return '';
  
  const turkishMap = {
    'ç': 'c', 'Ç': 'C',
    'ğ': 'g', 'Ğ': 'G',
    'ı': 'i', 'I': 'I',
    'İ': 'I', // Büyük İ karakteri
    'ö': 'o', 'Ö': 'O',
    'ş': 's', 'Ş': 'S',
    'ü': 'u', 'Ü': 'U'
  };
  
  // Tüm Türkçe karakterleri değiştir
  let cleanedText = text.replace(/[çÇğĞıIİöÖşŞüÜ]/g, match => turkishMap[match] || match);
  
  // Diğer problemli karakterleri de temizle
  cleanedText = cleanedText
    .replace(/['']/g, "'")  // Farklı apostroflar
    .replace(/[""]/g, '"')  // Farklı tırnak işaretleri
    .replace(/[–—]/g, '-')  // Farklı tireler
    .replace(/[…]/g, '...')  // Üç nokta
    .replace(/[€]/g, 'EUR')  // Euro işareti
    .replace(/[₺]/g, 'TL')  // Türk Lirası işareti
    .replace(/\s+/g, ' ')   // Çoklu boşlukları tek boşluğa çevir
    .trim();                // Başta ve sonda boşluk temizle
  
  return cleanedText;
};

/**
 * Bilgi alanı çizme yardımcı fonksiyonu
 */
const drawInfoField = (page, font, boldFont, x, y, label, value) => {
  drawTextSafely(page, label, {
    x: x,
    y: y,
    size: 11,
    font: boldFont,
    color: rgb(0, 0, 0),
  });
  
  drawTextSafely(page, value, {
    x: x,
    y: y - 15,
    size: 11,
    font: font,
    color: rgb(0, 0, 0),
  });
  
  return y - 35;
};

/**
 * Metni satırlara bölen yardımcı fonksiyon - PDF için optimize edilmiş
 */
const wrapText = (text, maxWidth) => {
  if (!text) return [''];
  
  // Önce metni temizle
  const cleanedText = cleanTurkishText(text);
  const words = cleanedText.split(' ');
  const lines = [];
  let currentLine = '';
  
  words.forEach(word => {
    const testLine = currentLine ? `${currentLine} ${word}` : word;
    if (testLine.length <= maxWidth) {
      currentLine = testLine;
    } else {
      if (currentLine) {
        lines.push(currentLine);
        currentLine = word;
      } else {
        // Tek kelime çok uzunsa, zorla böl
        lines.push(word.substring(0, maxWidth));
        currentLine = word.substring(maxWidth);
      }
    }
  });
  
  if (currentLine) lines.push(currentLine);
  return lines.length > 0 ? lines : [''];
};

/**
 * Metin yüksekliğini hesaplayan fonksiyon - responsive yapı için
 */
const calculateTextHeight = (text, font, maxWidth) => {
  if (!text) return 18; // 14pt font için uygun başlangıç yüksekliği
  
  const cleanedText = cleanTurkishText(text);
  const lines = wrapText(cleanedText, Math.floor(maxWidth / 8)); // 14pt font için daha uygun karakter genişliği
  
  return lines.length * 18; // Her satır için 18px (14pt font için uygun)
};

/**
 * Responsive metin çizme fonksiyonu - uzun metinler için
 */
const drawResponsiveText = (page, text, x, y, maxWidth, font, color = rgb(0, 0, 0)) => {
  if (!text) return 18;
  
  const cleanedText = cleanTurkishText(text);
  const lines = wrapText(cleanedText, Math.floor(maxWidth / 8)); // 14pt font için daha uygun
  
  lines.forEach((line, index) => {
    drawTextSafely(page, line, {
      x: x,
      y: y - (index * 18), // 18px satır yüksekliği
      size: 14, // HopsPlus ile aynı boyut (14pt)
      font: font,
      color: color
    });
  });
  
  return lines.length * 18;
};

/**
 * Toplam çalışma süresini hesaplayan fonksiyon - 3. saat desteği ile
 */
const calculateTotalWorkingTime = (puantajData) => {
  try {
    const parseTime = (timeStr) => {
      if (!timeStr || timeStr.trim() === '') return null;
      const [hours, minutes] = timeStr.split(':').map(Number);
      if (isNaN(hours) || isNaN(minutes)) return null;
      return { hours, minutes };
    };
    
    const calculateDuration = (start, end) => {
      if (!start || !end) return 0;
      
      let startMinutes = start.hours * 60 + start.minutes;
      let endMinutes = end.hours * 60 + end.minutes;
      
      // Gece yarısı geçişi kontrolü (bitiş saati başlangıç saatinden küçükse)
      if (endMinutes < startMinutes) {
        endMinutes += 24 * 60; // Ertesi güne geçiş
      }
      
      return endMinutes - startMinutes;
    };
    
    // Çoklu anahtar desteği ile saat bilgilerini al
    const start1 = parseTime(pickFirst(puantajData, ['startTime1', '1. Başlangıç Saati', '1. Baslangic Saati']));
    const end1 = parseTime(pickFirst(puantajData, ['endTime1', '1. Bitiş Saati', '1. Bitis Saati']));
    const start2 = parseTime(pickFirst(puantajData, ['startTime2', '2. Başlangıç Saati', '2. Baslangic Saati']));
    const end2 = parseTime(pickFirst(puantajData, ['endTime2', '2. Bitiş Saati', '2. Bitis Saati']));
    const start3 = parseTime(pickFirst(puantajData, ['startTime3', '3. Başlangıç Saati', '3. Baslangic Saati']));
    const end3 = parseTime(pickFirst(puantajData, ['endTime3', '3. Bitiş Saati', '3. Bitis Saati']));
    
    let totalMinutes = 0;
    
    // Her çalışma periyodunu hesapla
    totalMinutes += calculateDuration(start1, end1);
    totalMinutes += calculateDuration(start2, end2);
    totalMinutes += calculateDuration(start3, end3);
    
    if (totalMinutes <= 0) return '0:00';
    
    // Saat ve dakikaya çevir
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    
    // "8:30" formatında döndür
    return `${hours}:${minutes.toString().padStart(2, '0')}`;
  } catch (error) {
    console.error('Süre hesaplama hatası:', error);
    return '0:00';
  }
};

/**
 * Çalışma süresini dakikaya çeviren fonksiyon - Birden fazla format destekler
 * iOS HopsPlus ile AYNI MANTIK
 */
const parseWorkingTimeToMinutes = (timeString) => {
  if (!timeString || timeString.toString().trim() === '') return 0;

  const input = timeString.toString().trim();

  // Format 1: "2:30" veya "1:00" (HH:MM)
  if (input.includes(':') && !input.toLowerCase().includes('saat')) {
    const parts = input.split(':');
    if (parts.length === 2) {
      const hours = parseInt(parts[0].trim(), 10) || 0;
      const minutes = parseInt(parts[1].trim(), 10) || 0;
      return hours * 60 + minutes;
    }
  }

  // Format 2: "1 saat 0 dakika" veya "2 saat 30 dakika"
  if (input.toLowerCase().includes('saat')) {
    let hours = 0;
    let minutes = 0;
    const saatMatch = input.toLowerCase().match(/(\d+)\s*saat/);
    if (saatMatch) hours = parseInt(saatMatch[1], 10) || 0;
    const dakikaMatch = input.toLowerCase().match(/(\d+)\s*(dakika|dk)/);
    if (dakikaMatch) minutes = parseInt(dakikaMatch[1], 10) || 0;
    return hours * 60 + minutes;
  }

  // Format 3: "8.5" veya "8,5" (ondalık saat)
  const normalized = input.replace(',', '.');
  const decimalHours = parseFloat(normalized);
  if (!isNaN(decimalHours) && normalized.includes('.')) {
    return Math.round(decimalHours * 60);
  }

  // Format 4: Sadece sayı (dakika olarak)
  const justNumber = parseInt(input, 10);
  if (!isNaN(justNumber)) return justNumber;

  return 0;
};

/**
 * Süreyi "8 saat 30 dakika" formatına çeviren fonksiyon - Birden fazla format destekler
 * iOS HopsPlus ile AYNI MANTIK
 */
const formatTimeToReadable = (timeString) => {
  try {
    if (!timeString || timeString.toString().trim() === '' || timeString === '0:00') {
      return '0 saat 0 dakika';
    }
    
    // Zaten "X saat Y dakika" formatındaysa direkt döndür
    if (timeString.toLowerCase().includes('saat')) {
      return timeString;
    }
    
    // Diğer formatları parse et ve çevir
    const totalMinutes = parseWorkingTimeToMinutes(timeString);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    
    return `${hours} saat ${minutes} dakika`;
  } catch (error) {
    console.error('Süre formatı hatası:', error);
    return '0 saat 0 dakika';
  }
};

/**
 * PDF için puantaj fiyatı hesaplayan fonksiyon
 */
const calculatePuantajPriceForPDF = async (puantajData) => {
  try {
    // Firebase'den müşteri ve makine bilgilerini al
    const { getFirestore, collection, query, where, getDocs } = await import('firebase/firestore');
    const { auth } = await import('../components/firebaseConfig');
    
    const machineName = puantajData['Makine İsmi'] || puantajData['MakineIsmi'] || '';
    const customerName = puantajData['Müşteri Adı'] || '';
    const userEmail = auth.currentUser?.email;
    
    if (!userEmail || !machineName || !customerName) {
      console.warn('PDF fiyat hesaplama: Kullanıcı email, makine adı veya müşteri adı eksik');
      return null;
    }

    const db = getFirestore();

    // Önce müşterinin özel saatlik fiyatını kontrol et
    let hourlyRate = 0;
    const customerRef = collection(db, `users/${userEmail}/customerList`);
    const customerQuery = query(customerRef, where('Müşteri Adı', '==', customerName));
    const customerSnapshot = await getDocs(customerQuery);

    if (!customerSnapshot.empty) {
      const customerDoc = customerSnapshot.docs[0];
      const customerData = customerDoc.data();
      const specialHourlyRate = customerData['Özel Saatlik Fiyat'];
      
      if (specialHourlyRate !== undefined && specialHourlyRate !== null && specialHourlyRate !== '') {
        hourlyRate = parseFloat(specialHourlyRate);
        console.log('💰 PDF - Özel saatlik fiyat kullanılıyor:', hourlyRate, 'TL/saat');
      }
    }

    // Özel fiyat yoksa makine saatlik ücretini al
    if (hourlyRate === 0) {
      const machinesRef = collection(db, `users/${userEmail}/machines`);
      const machineQuery = query(machinesRef, where('MakineAdı', '==', machineName));
      const machineSnapshot = await getDocs(machineQuery);

      if (machineSnapshot.empty) {
        console.warn('PDF fiyat hesaplama: Makine bulunamadı:', machineName);
        return null;
      }

      const machineDoc = machineSnapshot.docs[0];
      hourlyRate = parseFloat(machineDoc.data().BirimFiyat || '0');
      console.log('🔧 PDF - Makine saatlik fiyatı kullanılıyor:', hourlyRate, 'TL/saat');
    }

    // Toplam çalışma süresini al ve saate çevir - iOS HopsPlus ile AYNI MANTIK
    const totalWorkingTime = calculateTotalWorkingTime(puantajData);
    const totalMinutes = parseWorkingTimeToMinutes(totalWorkingTime);
    const totalHours = totalMinutes / 60;

    const totalPrice = totalHours * hourlyRate;

    // Fiyatı formatlayıp döndür (HopsPlus formatında)
    return totalPrice.toLocaleString('tr-TR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }) + ' TL';

  } catch (error) {
    console.error('PDF fiyat hesaplama hatası:', error);
    return null;
  }
};

/**
 * PDF'i Firebase Storage'a yükleyen fonksiyon
 */
export const uploadPDFToStorage = async (pdfBytes, fileName, userEmail) => {
  try {
    const storage = getStorage();
    // PDF'leri kullanıcı email'ine göre subcollection'da sakla (iOS ile aynı mantık)
    const pdfRef = ref(storage, `pdfs/${userEmail}/${fileName}`);
    
    // PDF'i Blob olarak oluştur
    const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
    
    // Firebase Storage'a yükle
    const snapshot = await uploadBytes(pdfRef, pdfBlob);
    console.log('PDF başarıyla yüklendi:', snapshot.ref.fullPath);
    
    // Download URL'sini al
    const downloadURL = await getDownloadURL(pdfRef);
    
    console.log('🔗 PDF yüklendi - Download URL:', downloadURL);
    console.log('📁 PDF yolu:', pdfRef.fullPath);
    
    return {
      ref: pdfRef,
      downloadURL,
      fileName
    };
  } catch (error) {
    console.error('PDF yükleme hatası:', error);
    throw new Error('PDF yüklenirken bir hata oluştu: ' + error.message);
  }
};

/**
 * PDF'i Firebase Storage'a belirli path'e yükleyen fonksiyon
 */
export const uploadPDFToStorageWithPath = async (pdfBytes, storagePath) => {
  try {
    const storage = getStorage();
    const pdfRef = ref(storage, storagePath);
    
    // PDF'i Blob olarak oluştur
    const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
    
    // Firebase Storage'a yükle
    const snapshot = await uploadBytes(pdfRef, pdfBlob);
    console.log('📁 PDF belirli path\'e yüklendi:', snapshot.ref.fullPath);
    
    // Download URL'sini al
    const downloadURL = await getDownloadURL(pdfRef);
    
    console.log('🔗 PDF yüklendi - Download URL:', downloadURL);
    console.log('📁 PDF tam yolu:', pdfRef.fullPath);
    
    return {
      ref: pdfRef,
      downloadURL,
      fileName: storagePath.split('/').pop() // Son kısmı dosya adı olarak döndür
    };
  } catch (error) {
    console.error('❌ PDF belirli path\'e yükleme hatası:', error);
    throw new Error('PDF yüklenirken bir hata oluştu: ' + error.message);
  }
};

/**
 * Eski PDF'i silen fonksiyon
 */
export const deleteOldPDF = async (fileName, userEmail) => {
  try {
    const storage = getStorage();
    // PDF'leri kullanıcı email'ine göre subcollection'da sakla (iOS ile aynı mantık)
    const pdfRef = ref(storage, `pdfs/${userEmail}/${fileName}`);
    
    await deleteObject(pdfRef);
    console.log('🗑️ Eski PDF silindi:', fileName);
    return true;
  } catch (error) {
    // Dosya yoksa hata vermez, sadece log yapar
    console.log('ℹ️ Eski PDF bulunamadı (normal):', fileName);
    return false;
  }
};

/**
 * PDF URL'sinden orijinal tam path'i çıkaran fonksiyon
 * URL formatları: 
 * - Yeni: pdfs/userEmail/dosyaAdi.pdf
 * - Eski: pdfs/dosyaAdi.pdf
 * Döndürür: Tam storage path'i (pdfs/ ile başlayan)
 */
export const extractOriginalStoragePath = (pdfUrl) => {
  try {
    console.log('🔍🔍🔍 EXTRACT ORIGINAL STORAGE PATH BAŞLADI 🔍🔍🔍');
    console.log('📥 Gelen PDF URL:', pdfUrl);
    
    if (!pdfUrl || typeof pdfUrl !== 'string') {
      console.log('⚠️ PDF URL bulunamadı, orijinal path çıkarılamıyor');
      return null;
    }

    // URL'den path kısmını çıkar (Firebase Storage URL'si decode et)
    const decodedUrl = decodeURIComponent(pdfUrl);
    console.log('🔓 Decode edilmiş URL:', decodedUrl);
    
    // Birden fazla yöntemle "pdfs/" bulmaya çalış
    let pdfIndex = decodedUrl.indexOf('/pdfs/');
    console.log('📍 "/pdfs/" indexi (birinci deneme):', pdfIndex);
    
    if (pdfIndex === -1) {
      // Alternatif: sadece "pdfs/" ara (başında / olmadan)
      pdfIndex = decodedUrl.indexOf('pdfs/');
      console.log('📍 "pdfs/" indexi (ikinci deneme):', pdfIndex);
      
      if (pdfIndex === -1) {
        console.log('⚠️ PDF path bulunamadı URL\'de:', decodedUrl);
        return null;
      }
      
      // "pdfs/" ile başlıyorsa direkt al
      const pathAfterPdfs = decodedUrl.substring(pdfIndex);
      console.log('📂 pdfs ile başlayan path:', pathAfterPdfs);
      
      // "?" karakterine kadar olan kısmı al (query parametrelerini kaldır)
      const pathWithoutQuery = pathAfterPdfs.split('?')[0];
      console.log('🧹 Query parametreleri temizlendi:', pathWithoutQuery);
      
      console.log('📁📁📁 ORİJİNAL STORAGE PATH BULUNDU (ikinci yöntem):', pathWithoutQuery);
      return pathWithoutQuery;
    } else {
      // "/pdfs/" bulundu, sonrasını al
      const pathAfterPdfs = decodedUrl.substring(pdfIndex + 1); // "/pdfs/" başlangıcından itibaren, "/" hariç
      console.log('📂 /pdfs/ sonrası path:', pathAfterPdfs);
      
      // "?" karakterine kadar olan kısmı al (query parametrelerini kaldır)
      const pathWithoutQuery = pathAfterPdfs.split('?')[0];
      console.log('🧹 Query parametreleri temizlendi:', pathWithoutQuery);
      
      console.log('📁📁📁 ORİJİNAL STORAGE PATH BULUNDU (birinci yöntem):', pathWithoutQuery);
      return pathWithoutQuery;
    }
    
  } catch (error) {
    console.error('❌ PDF URL parse etme hatası:', error);
    return null;
  }
};

/**
 * PDF URL'sinden sadece dosya adını çıkaran fonksiyon (geriye uyumluluk için)
 */
export const extractOriginalFileName = (pdfUrl) => {
  try {
    const fullPath = extractOriginalStoragePath(pdfUrl);
    if (!fullPath) return null;
    
    // Path'in son kısmını al (dosya adı)
    const fileName = fullPath.split('/').pop();
    console.log('📄 Dosya adı çıkarıldı:', fileName);
    return fileName;
    
  } catch (error) {
    console.error('❌ Dosya adı çıkarma hatası:', error);
    return null;
  }
};

/**
 * Geçici PDF oluşturma fonksiyonu - Önizleme için temp_ prefix ile
 * Artık orijinal dosya adını kullanır
 */
export const createTemporaryPDF = async (puantajData, userInfo, userEmail, signatureDataUrl = null, showPuantajPrice = false, originalPdfUrl = null) => {
  try {
    console.log('🔄 Geçici PDF oluşturuluyor:', puantajData.id, {
      'İmza var mı': signatureDataUrl ? 'Evet' : 'Hayır',
      'Orijinal PDF URL': originalPdfUrl ? originalPdfUrl : 'Yok'
    });
    
    // Orijinal tam path'i bulmaya çalış
    let originalStoragePath = null;
    let originalFileName = null;
    let isOldFormat = false; // Format belirleme için
    
    if (originalPdfUrl) {
      originalStoragePath = extractOriginalStoragePath(originalPdfUrl);
      originalFileName = extractOriginalFileName(originalPdfUrl);
      console.log('📁 Orijinal path çıkarıldı:', originalStoragePath);
      
      // Format belirleme: eğer path'te email yoksa eski format
      if (originalStoragePath) {
        isOldFormat = !originalStoragePath.includes(`pdfs/${userEmail}/`);
        console.log('📊 Format belirlendi:', isOldFormat ? 'ESKİ FORMAT (pdfs/)' : 'YENİ FORMAT (pdfs/email/)');
        
        // ✅ ESKİ FORMATTAN YENİ FORMATA OTOMATİK GEÇİŞ
        if (isOldFormat && originalFileName) {
          console.log('🔄 Eski format tespit edildi, yeni formata geçiliyor...');
          originalStoragePath = `pdfs/${userEmail}/${originalFileName}`;
          isOldFormat = false;
          console.log('✅ Yeni format path oluşturuldu:', originalStoragePath);
        }
      }
    }
    
    // Orijinal path bulunamazsa default oluştur
    if (!originalStoragePath || !originalFileName) {
      const machineCode = puantajData['Makine İsmi'] || 'makine';
      const puantajNumber = puantajData['Puantaj Sayısı'] || 'puantaj';
      const contractNumber = `${machineCode}-${puantajNumber}`;
      originalFileName = `${contractNumber}.pdf`;
      
      // ✅ HER ZAMAN YENİ FORMAT KULLAN - Eski format desteği kaldırıldı
      originalStoragePath = `pdfs/${userEmail}/${originalFileName}`;
      isOldFormat = false;
      console.log('📄 Yeni format kullanılıyor (otomatik geçiş):', originalStoragePath);
    }
    
    console.log('🎯 KULLANILACAK FORMAT:', {
      'Orijinal Path': originalStoragePath,
      'Format': isOldFormat ? 'ESKİ (pdfs/)' : 'YENİ (pdfs/email/)',
      'Email': userEmail
    });
    
    // Geçici dosya için path oluştur - temp_ prefix ile aynı klasörde
    const pathParts = originalStoragePath.split('/');
    const fileName = pathParts.pop(); // Son kısmı al (dosya adı)
    const tempFileName = `temp_${fileName}`;
    const tempStoragePath = [...pathParts, tempFileName].join('/');
    
    console.log('📄 PDF path bilgileri:', {
      'Orijinal Path': originalStoragePath,
      'Geçici Path': tempStoragePath,
      'Orijinal Dosya': originalFileName,
      'Geçici Dosya': tempFileName
    });
    
    // PDF'i oluştur (imza ile birlikte)
    const pdfBytes = signatureDataUrl 
      ? await createPuantajPDFWithSignature(puantajData, userInfo, signatureDataUrl, showPuantajPrice)
      : (await createPuantajPDF(puantajData, userInfo, showPuantajPrice)).pdfBytes;
    
    // Geçici PDF'i yükle - tam path ile
    const uploadResult = await uploadPDFToStorageWithPath(pdfBytes, tempStoragePath);
    
    console.log('✅ Geçici PDF başarıyla oluşturuldu:', {
      'Upload Sonucu Dosya Adı': uploadResult.fileName,
      'Geçici Storage Path': tempStoragePath,
      'Orijinal Storage Path': originalStoragePath,
      'İmza dahil': signatureDataUrl ? 'Evet' : 'Hayır',
      'Orijinal PDF URL': originalPdfUrl ? 'Mevcut' : 'Yok'
    });
    
    // Cache busting için timestamp ekle
    const separator = uploadResult.downloadURL.includes('?') ? '&' : '?';
    const timestampedURL = `${uploadResult.downloadURL}${separator}t=${Date.now()}`;
    
    return {
      pdfURL: timestampedURL,
      fileName: uploadResult.fileName,
      tempFileName: tempFileName,
      originalFileName: originalFileName,
      tempStoragePath: tempStoragePath,
      originalStoragePath: originalStoragePath,
      pdfRef: uploadResult.ref
    };
    
  } catch (error) {
    console.error('❌ Geçici PDF oluşturma hatası:', error);
    throw error;
  }
};

/**
 * Geçici PDF'i kalıcı yapma fonksiyonu - Eski PDF'i siler, geçici PDF'i yeniden adlandırır
 * Artık direkt storage path'leri ile çalışır
 */
export const confirmTemporaryPDF = async (tempStoragePath, originalStoragePath) => {
  try {
    console.log('🔄🔄🔄 CONFIRM TEMPORARY PDF BAŞLADI 🔄🔄🔄');
    console.log('✅ Geçici PDF kalıcı yapılıyor:', { 
      tempStoragePath, 
      originalStoragePath 
    });
    console.log('📍 Temp Storage Path Detay:', tempStoragePath);
    console.log('📍 Original Storage Path Detay:', originalStoragePath);
    
    const storage = getStorage();
    const tempRef = ref(storage, tempStoragePath);
    const originalRef = ref(storage, originalStoragePath);
    
    console.log('🔗 Firebase Ref\'ler oluşturuldu:', {
      'Temp Ref Full Path': tempRef.fullPath,
      'Original Ref Full Path': originalRef.fullPath
    });
    
    // 1. Geçici PDF'i indir
    const tempURL = await getDownloadURL(tempRef);
    const response = await fetch(tempURL);
    const pdfBytes = await response.arrayBuffer();
    
    // 2. Eski PDF'i sil (eğer varsa)
    try {
      await deleteObject(originalRef);
      console.log('🗑️ Eski PDF silindi:', originalStoragePath);
    } catch (error) {
      console.log('ℹ️ Eski PDF bulunamadı (normal):', originalStoragePath);
    }
    
    // 3. Geçici PDF'i kalıcı isimle yükle
    console.log('📤 PDF kalıcı isimle yükleniyor:', originalRef.fullPath);
    const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
    const uploadSnapshot = await uploadBytes(originalRef, pdfBlob);
    console.log('✅ PDF başarıyla yüklendi:', uploadSnapshot.ref.fullPath);
    
    // 4. Geçici PDF'i sil
    await deleteObject(tempRef);
    console.log('🗑️ Geçici PDF silindi:', tempStoragePath);
    
    // 5. Kalıcı PDF URL'sini döndür
    const finalURL = await getDownloadURL(originalRef);
    console.log('🔗 Final PDF URL alındı:', finalURL);
    
    console.log('✅✅✅ PDF KALICI YAPILDI - HEDEF ADRESİ:', originalStoragePath);
    console.log('📍 Firebase Storage\'da gerçek konum:', uploadSnapshot.ref.fullPath);
    
    return {
      pdfURL: finalURL,
      fileName: originalStoragePath.split('/').pop() // Dosya adını path'in sonundan al
    };
    
  } catch (error) {
    console.error('❌ Geçici PDF kalıcı yapma hatası:', error);
    throw error;
  }
};

/**
 * Geçici PDF'i silme fonksiyonu - İptal durumunda
 * Artık storage path ile çalışır
 */
export const deleteTemporaryPDF = async (tempStoragePath) => {
  try {
    console.log('🗑️ Geçici PDF siliniyor:', tempStoragePath);
    
    const storage = getStorage();
    const tempRef = ref(storage, tempStoragePath);
    
    await deleteObject(tempRef);
    console.log('✅ Geçici PDF başarıyla silindi:', tempStoragePath);
    
    return true;
  } catch (error) {
    console.log('ℹ️ Geçici PDF bulunamadı (normal):', tempStoragePath);
    return false;
  }
};

/**
 * Ana PDF yeniden oluşturma fonksiyonu - Eski dosyayı siler ve yenisini oluşturur
 */
export const regeneratePuantajPDF = async (puantajData, userInfo, userEmail, showPuantajPrice = false) => {
  try {
    console.log('🔄 PDF yeniden oluşturuluyor:', puantajData.id);
    console.log('📄 Güncellenmiş puantaj verisi:', {
      'Müşteri Adı': puantajData['Müşteri Adı'],
      'Makine İsmi': puantajData['Makine İsmi'],
      'Operatör Adı': puantajData['Operatör Adı'],
      'Tarih': puantajData['Tarih'],
      '1. Başlangıç Saati': puantajData['1. Başlangıç Saati'],
      '1. Bitiş Saati': puantajData['1. Bitiş Saati'],
      'Çalışma Detayı': puantajData['Çalışma Detayı']
    });
    
    // Dosya adını oluştur: makine kodu-puantaj numarası = sözleşme numarası
    const machineCode = puantajData['Makine İsmi'] || 'makine';
    const puantajNumber = puantajData['Puantaj Sayısı'] || 'puantaj';
    const contractNumber = `${machineCode}-${puantajNumber}`;
    const fileName = `${contractNumber}.pdf`;
    
    console.log('📄 PDF dosya adı oluşturuluyor:', {
      'Makine Kodu': machineCode,
      'Puantaj Numarası': puantajNumber,
      'Sözleşme Numarası': contractNumber,
      'Dosya Adı': fileName
    });
    
    // ADIM 1: Eski PDF'i sil (eğer varsa)
    await deleteOldPDF(fileName, userEmail);
    
    // ADIM 2: Yeni PDF'i oluştur
    const result = await createPuantajPDF(puantajData, userInfo, showPuantajPrice);
    const pdfBytes = result.pdfBytes;
    
    // ADIM 3: Yeni PDF'i yükle (aynı dosya adıyla)
    const uploadResult = await uploadPDFToStorage(pdfBytes, fileName, userEmail);
    
    console.log('✅ PDF başarıyla yeniden oluşturuldu ve eski dosya değiştirildi:', uploadResult.fileName);
    
    // Cache busting için timestamp ekle (URL'de zaten ? varsa & kullan)
    const separator = uploadResult.downloadURL.includes('?') ? '&' : '?';
    const timestampedURL = `${uploadResult.downloadURL}${separator}t=${Date.now()}`;
    
    console.log('🔗 Timestamped URL:', timestampedURL);
    
    return {
      pdfURL: timestampedURL,
      fileName: uploadResult.fileName,
      pdfRef: uploadResult.ref
    };
    
  } catch (error) {
    console.error('❌ PDF yeniden oluşturma hatası:', error);
    throw error;
  }
};

// PDF.js dinamik import için
let pdfjsLib = null;

/**
 * PDF.js'i dinamik olarak yükle
 */
const loadPDFJS = async () => {
  if (!pdfjsLib) {
    pdfjsLib = await import('pdfjs-dist');
    pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
  }
  return pdfjsLib;
};

/**
 * 🎨 UNIVERSAL İmza Çıkarma - Tüm Yazıları Temizleyen Sistem
 * Canvas'tan TÜM yazıları temizler, sadece kalemle çizilmiş imzayı bırakır
 * Her türlü puantaj formatında (imza üstte/altta/ortada) çalışır
 */
const extractSignatureArea = (canvas, viewport) => {
  try {
    console.log('🎯 UNIVERSAL İmza çıkarma başlıyor...');
    
    // Ana canvas'ın bir kopyasını oluştur
    const cleanCanvas = document.createElement('canvas');
    const cleanCtx = cleanCanvas.getContext('2d');
    cleanCanvas.width = canvas.width;
    cleanCanvas.height = canvas.height;
    
    // Orijinal canvas'ı kopyala
    cleanCtx.drawImage(canvas, 0, 0);
    
    // 🧹 TÜM YAZILARI TEMİZLE - Universal yaklaşım
    console.log('🧹 Tüm yazıları temizliyor (form yazıları, başlıklar, çizgiler)...');
    
    // Canvas'ı piksel piksel tara ve sadece el yazısını koru
    const imageData = cleanCtx.getImageData(0, 0, cleanCanvas.width, cleanCanvas.height);
    const data = imageData.data;
    const cleanedData = new Uint8ClampedArray(data.length);
    
    // Beyaz background ile başla
    for (let i = 0; i < cleanedData.length; i += 4) {
      cleanedData[i] = 255;     // R
      cleanedData[i + 1] = 255; // G
      cleanedData[i + 2] = 255; // B
      cleanedData[i + 3] = 255; // A
    }
    
    let handwritingPixelCount = 0;
    let minX = Infinity, maxX = -Infinity;
    let minY = Infinity, maxY = -Infinity;
    
    // İmza piksellerini kolayca analiz edebilmek için binary maske tut
    const handwritingMask = new Uint8Array(cleanCanvas.width * cleanCanvas.height); // 0 = arka plan, 1 = el yazısı
    
    // Her pikseli kontrol et
    for (let y = 0; y < cleanCanvas.height; y++) {
      for (let x = 0; x < cleanCanvas.width; x++) {
        const i = (y * cleanCanvas.width + x) * 4;
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        const alpha = data[i + 3];
        
        if (alpha > 0) {
          // El yazısı tespiti - çok geniş kriterler
          const isHandwriting = detectHandwritingPixel(r, g, b, x, y, cleanCanvas.width, cleanCanvas.height, data);
          
          if (isHandwriting) {
            // Bu piksel el yazısı - koru
            cleanedData[i] = r;
            cleanedData[i + 1] = g;
            cleanedData[i + 2] = b;
            cleanedData[i + 3] = alpha;
            
            // Maskeyi işaretle
            handwritingMask[y * cleanCanvas.width + x] = 1;
            
            // Sınırları güncelle
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
            handwritingPixelCount++;
          }
        }
      }
    }
    
    // Temizlenmiş veriyi canvas'a uygula
    const cleanedImageData = new ImageData(cleanedData, cleanCanvas.width, cleanCanvas.height);
    cleanCtx.putImageData(cleanedImageData, 0, 0);
    
    console.log(`✍️ El yazısı analizi tamamlandı:`, {
      'Toplam el yazısı pikseli': handwritingPixelCount,
      'İmza sınırları': handwritingPixelCount > 0 ? `x:${minX}-${maxX}, y:${minY}-${maxY}` : 'Bulunamadı'
    });
    
    // Yeterli el yazısı var mı?
    if (handwritingPixelCount < 100) {
      console.log('⚠️ Yeterli el yazısı bulunamadı');
      return null;
    }
    
    // ------------------------------------------------------------
    // ✨ EN BÜYÜK EL YAZISI BİLEŞENİNİ BUL (Connected-Component Analysis)
    // ------------------------------------------------------------
    const widthC = cleanCanvas.width;
    const heightC = cleanCanvas.height;
    const visited = new Uint8Array(handwritingMask.length);
    let bestCluster = { pixels: 0, minX: 0, minY: 0, maxX: 0, maxY: 0 };

    const stack = [];
    const push = (idx) => { stack.push(idx); visited[idx] = 1; };

    for (let y = 0; y < heightC; y++) {
      for (let x = 0; x < widthC; x++) {
        const startIdx = y * widthC + x;
        if (handwritingMask[startIdx] && !visited[startIdx]) {
          // Yeni cluster başlat
          let cMinX = x, cMaxX = x, cMinY = y, cMaxY = y;
          let pixels = 0;
          stack.length = 0;
          push(startIdx);

          while (stack.length) {
            const idx = stack.pop();
            const cy = Math.floor(idx / widthC);
            const cx = idx - cy * widthC;

            pixels++;
            if (cx < cMinX) cMinX = cx;
            if (cx > cMaxX) cMaxX = cx;
            if (cy < cMinY) cMinY = cy;
            if (cy > cMaxY) cMaxY = cy;

            // 8-komşuluk
            for (let ny = cy - 1; ny <= cy + 1; ny++) {
              for (let nx = cx - 1; nx <= cx + 1; nx++) {
                if (nx === cx && ny === cy) continue;
                if (nx >= 0 && nx < widthC && ny >= 0 && ny < heightC) {
                  const nIdx = ny * widthC + nx;
                  if (handwritingMask[nIdx] && !visited[nIdx]) {
                    push(nIdx);
                  }
                }
              }
            }
          }

          // Küme metrikleri
          const cWidth = cMaxX - cMinX + 1;
          const cHeight = cMaxY - cMinY + 1;
          const cArea = cWidth * cHeight;
          const density = pixels / cArea; // 0-1 arası
          const aspectRatio = Math.max(cWidth / cHeight, cHeight / cWidth);

          // Çok ince çizgileri (kalınlık ≤ 6px) imza adaylarından çıkar
          const looksLikeThinLine = (cHeight <= 6 || cWidth <= 6);

          // DÜZ ÇİZGİ / SINIR FİLTRESİ
          // Çok ince-uzun (aspectRatio > 6) VE düşük yoğunluklu (density < 0.15) ise sınır kabul et ve atla
          const looksLikeBorderLine = aspectRatio > 6 && density < 0.15;

          // Eğer sınır veya ince çizgi ise atla
          if (looksLikeBorderLine || looksLikeThinLine) {
            continue;
          }

          if (!looksLikeBorderLine && pixels > bestCluster.pixels) {
             bestCluster = { pixels, minX: cMinX, minY: cMinY, maxX: cMaxX, maxY: cMaxY };
          }
        }
      }
    }

    // Eğer anlamlı bir cluster bulunduysa, crop sınırlarını güncelle
    if (bestCluster.pixels >= 80) {
      console.log('🔎 En büyük el yazısı bileşeni bulundu:', bestCluster);
      minX = bestCluster.minX;
      maxX = bestCluster.maxX;
      minY = bestCluster.minY;
      maxY = bestCluster.maxY;
    } else {
      console.log('⚠️ Bileşen analizi başarısız, eski sınırlar kullanılacak');
    }

    // 🎯 İMZA ALANINI CROP ET
    const padding = 25; // Geniş padding
    const cropX = Math.max(0, minX - padding);
    const cropY = Math.max(0, minY - padding);
    const cropWidth = Math.min(cleanCanvas.width - cropX, (maxX - minX + 1) + (padding * 2));
    const cropHeight = Math.min(cleanCanvas.height - cropY, (maxY - minY + 1) + (padding * 2));
    
    // Final imza canvas'ı oluştur
    const signatureCanvas = document.createElement('canvas');
    const signatureCtx = signatureCanvas.getContext('2d');
    signatureCanvas.width = cropWidth;
    signatureCanvas.height = cropHeight;
    
    // Temizlenmiş imzayı crop et
    signatureCtx.drawImage(
      cleanCanvas,
      cropX, cropY, cropWidth, cropHeight, // source
      0, 0, cropWidth, cropHeight // destination
    );
    
    console.log('🎯 UNIVERSAL İmza crop tamamlandı:', {
      'Orijinal canvas': `${cleanCanvas.width}x${cleanCanvas.height}`,
      'Crop alanı': `x:${cropX}, y:${cropY}, w:${cropWidth}, h:${cropHeight}`,
      'Yüzde konum': `x:${(cropX/cleanCanvas.width*100).toFixed(1)}%, y:${(cropY/cleanCanvas.height*100).toFixed(1)}%`,
      'İmza boyutu': `${cropWidth}x${cropHeight}`
    });
    
    // Base64 olarak döndür
    return signatureCanvas.toDataURL('image/png', 0.95);
    
  } catch (error) {
    console.error('❌ Universal imza çıkarma hatası:', error);
    return null;
  }
};

/**
 * ✍️ El Yazısı Piksel Tespiti - Çok Akıllı Algoritma
 * Bir pikselin el yazısı olup olmadığını çok detaylı kriterlerle tespit eder
 */
const detectHandwritingPixel = (r, g, b, x, y, width, height, imageData) => {
  const brightness = (r + g + b) / 3;
  
  // ️✒️ SADECE SİYAH / GRİ TONLU KALEM TESPİTİ
  // İmzanın her zaman siyah olduğu belirtildi – renkli (mavi/kırmızı) pikselleri ele.
  const isBlackPenColor = (
    brightness < 200 &&                // Yeterince koyu
    r < 150 && g < 150 && b < 150 &&   // Kanallar koyu
    Math.abs(r - g) < 25 &&            // R,G,B birbirine yakın → gri/siyah
    Math.abs(r - b) < 25 &&
    Math.abs(g - b) < 25
  );
  if (!isBlackPenColor) return false;
  
  // 🔍 ÇEVRE ANALİZİ - Form yazılarını filtrele
  const surroundingAnalysis = analyzeSurrounding(x, y, width, height, imageData);
  
  // Form yazısı (düzenli, grid-like) değil mi?
  const isNotFormText = (
    surroundingAnalysis.irregularity > 0.3 ||  // Düzensiz çevre
    surroundingAnalysis.density < 0.7 ||       // Düşük yoğunluk
    surroundingAnalysis.variation > 0.4        // Renk varyasyonu
  );
  
  return isNotFormText;
};

/**
 * 🔍 Çevre Analizi - Pikselin çevresini analiz eder
 * Form yazıları vs el yazısını ayırt etmek için
 */
const analyzeSurrounding = (centerX, centerY, width, height, imageData) => {
  const radius = 8; // Analiz yarıçapı
  let totalPixels = 0;
  let darkPixels = 0;
  let colorVariations = 0;
  let lastBrightness = -1;
  
  // Çevredeki pikselleri tara
  for (let dy = -radius; dy <= radius; dy++) {
    for (let dx = -radius; dx <= radius; dx++) {
      const x = centerX + dx;
      const y = centerY + dy;
      
      // Sınır kontrolü
      if (x >= 0 && x < width && y >= 0 && y < height) {
        const i = (y * width + x) * 4;
        const r = imageData[i];
        const g = imageData[i + 1];
        const b = imageData[i + 2];
        const alpha = imageData[i + 3];
        
        if (alpha > 0) {
          const brightness = (r + g + b) / 3;
          totalPixels++;
          
          if (brightness < 200) {
            darkPixels++;
          }
          
          // Renk varyasyonu hesapla
          if (lastBrightness >= 0) {
            const diff = Math.abs(brightness - lastBrightness);
            if (diff > 30) {
              colorVariations++;
            }
          }
          lastBrightness = brightness;
        }
      }
    }
  }
  
  // Analiz sonuçları
  const density = totalPixels > 0 ? darkPixels / totalPixels : 0;
  const irregularity = totalPixels > 0 ? colorVariations / totalPixels : 0;
  const variation = totalPixels > 0 ? colorVariations / Math.max(totalPixels, 1) : 0;
  
  return {
    density: density,        // Çevredeki koyu piksel yoğunluğu
    irregularity: irregularity, // Düzensizlik oranı
    variation: variation     // Renk varyasyon oranı
  };
};

/**
 * 🚀 Gelişmiş PDF Oluşturma - İmza Desteği ile
 */
export const createPuantajPDFWithSignature = async (puantajData, userInfo, signatureDataUrl = null, showPuantajPrice = false) => {
  try {
    console.log('📄 İmzalı PDF oluşturma başladı:', {
      'Müşteri': puantajData['Müşteri Adı'],
      'İmza var mı': signatureDataUrl ? 'Evet' : 'Hayır'
    });
    
    // Normal PDF oluştur
    const result = await createPuantajPDF(puantajData, userInfo, showPuantajPrice);
    
    // İmza varsa PDF'e ekle
    if (signatureDataUrl) {
      return await addSignatureToPDF(result.pdfBytes, signatureDataUrl, result.yetkiliImzasiYPosition);
    }
    
    return result.pdfBytes;
    
  } catch (error) {
    console.error('❌ İmzalı PDF oluşturma hatası:', error);
    throw error;
  }
};

/**
 * 🖋️ PDF'e İmza Ekleme
 * Mevcut PDF'e imza görselini ekler
 */
const addSignatureToPDF = async (pdfBytes, signatureDataUrl, yetkiliImzasiYPosition) => {
  try {
    console.log('🖋️ PDF\'e imza ekleniyor...');
    
    // PDF'i yükle
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    const { width, height } = firstPage.getSize();
    
    // İmza görselini embed et
    let signatureImage;
    try {
      // Base64 string'i buffer'a çevir
      const base64Data = signatureDataUrl.split(',')[1];
      const imageBytes = Uint8Array.from(atob(base64Data), c => c.charCodeAt(0));
      signatureImage = await pdfDoc.embedPng(imageBytes);
    } catch (error) {
      console.error('❌ İmza embed hatası:', error);
      throw new Error('İmza PDF\'e eklenemedi');
    }
    
    // İmza boyutu kenarlıklar dahil 100x100 piksel olacak
    const TOTAL_BOX_SIZE = 100; // Kenarlıklar dahil toplam boyut
    const BORDER_WIDTH = 0.5; // Daha ince kenarlık
    const signatureWidth = TOTAL_BOX_SIZE - (BORDER_WIDTH * 2); // İç alan boyutu
    const signatureHeight = TOTAL_BOX_SIZE - (BORDER_WIDTH * 2);
    
    // İmza konumu: "Yetkili Imzasi" yazısının hemen altında, sol hizalı
    const signatureX = 50; // Yazı ile aynı X pozisyonu (leftMargin + 10 = 40 + 10 = 50)
    // İmzanın yazının hemen altında olması için:
    // drawImage Y koordinatı imzanın ALT-SOL köşesini referans alır
    // Yazı Y pozisyonu - küçük boşluk - imza yüksekliği = imza alt köşesi
    const signatureY = yetkiliImzasiYPosition - 15 - signatureHeight; // Yazının 15px altından imza üst kısmı başlasın
    
    // İmzanın etrafına siyah çerçeve çiz (kenarlıklar dahil 100x100)
    firstPage.drawRectangle({
      x: signatureX,
      y: signatureY,
      width: TOTAL_BOX_SIZE,
      height: TOTAL_BOX_SIZE,
      borderColor: rgb(0, 0, 0), // Siyah çerçeve
      borderWidth: BORDER_WIDTH, // İnce kenarlık
      color: rgb(1, 1, 1) // Beyaz arka plan
    });
    
    // İmzayı PDF'e çiz (çerçevenin tam merkezine)
    const originalSignatureWidth = signatureImage.width;
    const originalSignatureHeight = signatureImage.height;
    
    // İmzayı kutu içinde merkeze almak için oranı koru
    let drawWidth = signatureWidth;
    let drawHeight = signatureHeight;
    
    // Aspect ratio'yu koruyarak kutu içine sığdır
    const aspectRatio = originalSignatureWidth / originalSignatureHeight;
    if (aspectRatio > 1) {
      // Yatay imza
      drawHeight = drawWidth / aspectRatio;
    } else {
      // Dikey imza
      drawWidth = drawHeight * aspectRatio;
    }
    
    // Merkeze almak için offset hesapla
    const offsetX = (signatureWidth - drawWidth) / 2;
    const offsetY = (signatureHeight - drawHeight) / 2;
    
    firstPage.drawImage(signatureImage, {
      x: signatureX + BORDER_WIDTH + offsetX,
      y: signatureY + BORDER_WIDTH + offsetY,
      width: drawWidth,
      height: drawHeight,
      opacity: 0.9
    });
    
    console.log('✅ İmza PDF\'e eklendi (merkezlenmiş, kenarlıklar dahil 100x100):', {
      konum: `x:${signatureX.toFixed(2)}, y:${signatureY.toFixed(2)}`,
      yetkiliImzasiY: yetkiliImzasiYPosition,
      toplamBoyut: `${TOTAL_BOX_SIZE}x${TOTAL_BOX_SIZE}px (kenarlıklar dahil)`,
      imzaBoyutu: `${signatureWidth}x${signatureHeight}px (iç alan)`,
      orijinalImzaBoyutu: `${originalSignatureWidth}x${originalSignatureHeight}px`,
      cizimBoyutu: `${drawWidth.toFixed(1)}x${drawHeight.toFixed(1)}px`,
      merkezOffset: `x:${offsetX.toFixed(1)}, y:${offsetY.toFixed(1)}`,
      kenarlık: `${BORDER_WIDTH}px (ince kenarlık)`,
      hizalama: 'Sol hizalı + merkeze alınmış'
    });
    
    // Güncellenmiş PDF'i döndür
    return await pdfDoc.save();
    
  } catch (error) {
    console.error('❌ İmza ekleme hatası:', error);
    throw error;
  }
};

/**
 * pdf.js kütüphanesini dinamik olarak yükleyen yardımcı fonksiyon.
 */
const loadPdfJs = async () => {
  try {
    // pdf.js'i worker'ı ile birlikte import et
    const pdfjs = await import('pdfjs-dist/build/pdf');
    const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.entry');
    pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
    return pdfjs;
  } catch (error) {
    console.error('pdf.js yüklenemedi. Projenize eklediğinizden emin olun: npm install pdfjs-dist');
    return null;
  }
};

/**
 * Mevcut bir PDF'ten imzayı, pikselleri analiz ederek çıkaran en sağlam yöntem.
 * @param {string} pdfUrl - Eski PDF'in URL'si.
 * @returns {Promise<string|null>} - İmzanın PNG formatında base64 data URL'si veya null.
 */
export const extractSignatureFromOldPDF = async (pdfUrl) => {
  try {
    console.log(`[Piksel Analizi] 🔍 İmza çıkarma işlemi başlatıldı...`);
    
    const pdfjs = await loadPdfJs();
    if (!pdfjs) throw new Error('PDF.js kütüphanesi yüklenemedi.');

    const loadingTask = pdfjs.getDocument(pdfUrl);
    const pdf = await loadingTask.promise;
    const page = await pdf.getPage(1);
    
    // Yüksek çözünürlük için ölçeği artır
    const scale = 2.0;
    const viewport = page.getViewport({ scale });

    // Arka planda bir canvas oluştur
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.height = viewport.height;
    canvas.width = viewport.width;

    // PDF sayfasını canvas'a çiz
    await page.render({ canvasContext: context, viewport }).promise;

    // 1) HopsPlus koordinat yöntemi ile hızlı imza yakalama denemesi
    const byLabelDataUrl = await extractSignatureByLabel(page, viewport, canvas);
    if (byLabelDataUrl) {
      return byLabelDataUrl; // İmza bulundu, işlemi erken sonlandır
    }

    // --- YAZILARI SİLME (CERRAHİ YÖNTEM) ---
    console.log('✍️ Canvas üzerindeki yazılar beyaz ile kaplanıyor...');
    const textContent = await page.getTextContent();
    context.fillStyle = 'white'; // Temizleme rengi
    
    // Yazıların viewport üzerindeki koordinatlarını al ve üzerlerini boya
    for (const item of textContent.items) {
      const tx = item.transform;
      const textWidth = item.width * scale;
      const textHeight = item.height * scale;
      const [x, y] = viewport.convertToViewportPoint(tx[4], tx[5]);
      // Y eksenini düzeltmek için textHeight çıkarılır ve küçük bir pay bırakılır
      context.fillRect(x - 1, y - textHeight - 1, textWidth + 2, textHeight + 2);
    }
    console.log('✅ Yazılar başarıyla temizlendi.');
    // -----------------------------------------

    // Arama alanını tanımla (sağ alt, Y ekseni 50px aşağı kaydırılmış ve daraltılmış)
    const yStart = Math.floor(canvas.height / 2) + 50;
    const searchArea = {
      x: Math.floor(canvas.width / 2),
      y: yStart,
      width: Math.floor(canvas.width / 2),
      height: canvas.height - yStart, // Canvas'ın alt sonuna kadar
    };
    console.log('🎯 Daraltılmış Arama Alanı:', searchArea);

    const imageData = context.getImageData(searchArea.x, searchArea.y, searchArea.width, searchArea.height);
    const data = imageData.data;

    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    let foundSignature = false;

    // Pikselleri tara ve imza piksellerini bul (daha hassas eşik)
    for (let y = 0; y < searchArea.height; y++) {
      for (let x = 0; x < searchArea.width; x++) {
        const i = (y * searchArea.width + x) * 4;
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        const a = data[i + 3];

        // Daha hassas piksel algılama - açık gri tonları da dahil
        if (a > 0 && (r < 240 || g < 240 || b < 240)) {
          foundSignature = true;
          if (x < minX) minX = x;
          if (y < minY) minY = y;
          if (x > maxX) maxX = x;
          if (y > maxY) maxY = y;
        }
      }
    }

    if (!foundSignature) {
      console.log('🚫 Piksel analizinde imza bulunamadı.');
      return null;
    }

    console.log(`🎯 İmza bounding box: minX=${minX}, maxX=${maxX}, minY=${minY}, maxY=${maxY}`);
    console.log(`📏 İmza boyutları: width=${maxX - minX + 1}, height=${maxY - minY + 1}`);

    // İmzanın tam kenarlarını yakalamak için genişletilmiş tarama
    const expandedMinX = Math.max(0, minX - 5);
    const expandedMaxX = Math.min(searchArea.width - 1, maxX + 5);
    const expandedMinY = Math.max(0, minY - 5);
    const expandedMaxY = Math.min(searchArea.height - 1, maxY + 5);

    console.log(`🔍 Genişletilmiş bounding box: minX=${expandedMinX}, maxX=${expandedMaxX}, minY=${expandedMinY}, maxY=${expandedMaxY}`);

    // İmzayı sıkıca saran bir bounding box oluştur + padding ekle
    const padding = 8; // Optimum padding
    const signatureWidth = expandedMaxX - expandedMinX + 1 + (padding * 2);
    const signatureHeight = expandedMaxY - expandedMinY + 1 + (padding * 2);

    // Yeni, temiz bir canvas oluştur ve sadece imzayı çiz
    const signatureCanvas = document.createElement('canvas');
    signatureCanvas.width = signatureWidth;
    signatureCanvas.height = signatureHeight;
    const signatureContext = signatureCanvas.getContext('2d');
    
    // Beyaz arka plan ekle
    signatureContext.fillStyle = 'white';
    signatureContext.fillRect(0, 0, signatureWidth, signatureHeight);
    
    signatureContext.drawImage(
      canvas,
      searchArea.x + expandedMinX - padding, // Orijinal canvas'taki başlangıç X (genişletilmiş + padding)
      searchArea.y + expandedMinY - padding, // Orijinal canvas'taki başlangıç Y (genişletilmiş + padding)
      signatureWidth,
      signatureHeight,
      0, // Hedef canvas'taki başlangıç X
      0, // Hedef canvas'taki başlangıç Y
      signatureWidth,
      signatureHeight
    );

    const dataUrl = signatureCanvas.toDataURL('image/png');
    console.log('✅ İmza, piksel analizi ile başarıyla çıkarıldı.');
    return dataUrl;

  } catch (error) {
    console.error('❌ Piksel tabanlı imza çıkarma sırasında hata:', error);
    return null;
  }
};

/**
 * Bir imza kutusu canvas'ındaki siyah çerçeveyi tespit eder ve
 * çerçeve sınırlarıyla tam olarak kırpılmış yeni bir canvas döndürür.
 * @param {HTMLCanvasElement} canvas - İmzanın bulunduğu canvas (çevresinde beyaz alan olabilir)
 * @returns {HTMLCanvasElement} - Çerçeve sınırlarına göre kırpılmış canvas
 */
const refineBoundingBoxWithBorder = (canvas) => {
  const ctx = canvas.getContext('2d');
  const { width, height } = canvas;
  const data = ctx.getImageData(0, 0, width, height).data;
  const isDark = (r, g, b, a) => a > 0 && r < 60 && g < 60 && b < 60;

  // Yardımcı: bir sütunda kaç koyu piksel var?
  const darkPixelsInCol = (x) => {
    let count = 0;
    for (let y = 0; y < height; y++) {
      const i = (y * width + x) * 4;
      if (isDark(data[i], data[i + 1], data[i + 2], data[i + 3])) count++;
    }
    return count;
  };
  // Yardımcı: bir satırda kaç koyu piksel var?
  const darkPixelsInRow = (y) => {
    let count = 0;
    for (let x = 0; x < width; x++) {
      const i = (y * width + x) * 4;
      if (isDark(data[i], data[i + 1], data[i + 2], data[i + 3])) count++;
    }
    return count;
  };

  const colThreshold = Math.floor(height * 0.6); // sütunun %60'ı siyah ise kenar olabilir
  const rowThreshold = Math.floor(width * 0.6);

  let minX = 0;
  for (let x = 0; x < width; x++) {
    if (darkPixelsInCol(x) >= colThreshold) { minX = x; break; }
  }
  let maxX = width - 1;
  for (let x = width - 1; x >= 0; x--) {
    if (darkPixelsInCol(x) >= colThreshold) { maxX = x; break; }
  }
  let minY = 0;
  for (let y = 0; y < height; y++) {
    if (darkPixelsInRow(y) >= rowThreshold) { minY = y; break; }
  }
  let maxY = height - 1;
  for (let y = height - 1; y >= 0; y--) {
    if (darkPixelsInRow(y) >= rowThreshold) { maxY = y; break; }
  }

  // Güvenlik: değerlerin mantıklı olup olmadığını kontrol et
  if (maxX - minX < 20 || maxY - minY < 20) {
    console.warn('⚠️ Çerçeve sınırları güvenilir bulunamadı, orijinal canvas döndürülüyor.');
    return canvas;
  }

  const newW = maxX - minX + 1;
  const newH = maxY - minY + 1;
  const out = document.createElement('canvas');
  out.width = newW;
  out.height = newH;
  out.getContext('2d').drawImage(canvas, minX, minY, newW, newH, 0, 0, newW, newH);
  return out;
};

// HopsPlus'taki Swift algoritmasından esinlenen, "YETKILI IMZASI" etiketinin hemen
// altındaki 100×100 px kareyi kırpıp imza olup olmadığını kontrol eden yardımcı fonksiyon
const extractSignatureByLabel = async (page, viewport, canvas) => {
  try {
    console.log('🔍 Etiket arama başlıyor...');
    const textContent = await page.getTextContent();
    console.log(`📄 Toplam metin item sayısı: ${textContent.items.length}`);

    // Tüm metin item'larını normalize edip sakla
    const items = textContent.items.map((it) => {
      const txt = (it.str || '').toUpperCase().replace(/İ/g, 'I');
      return { txt, item: it };
    });

    // Debug: tüm metinleri logla
    console.log('📝 PDF\'teki tüm metinler:', items.map(i => i.txt).join(' | '));

    // 'YETKILI' ve 'IMZASI' içeren item'ları topla
    
    // Parçalanmış metinleri birleştirerek kelime arama
    const findFragmentedText = (searchText, tolerance = 50) => {
      const results = [];
      for (let i = 0; i < items.length; i++) {
        const startItem = items[i];
        if (!startItem.txt) continue;
        
        // Bu item'dan başlayarak kelimeyi oluşturmaya çalış
        let combined = '';
        let usedItems = [startItem];
        let currentX = startItem.item.transform[4];
        let currentY = startItem.item.transform[5];
        
        // Sonraki item'ları kontrol et
        for (let j = i; j < Math.min(i + 15, items.length); j++) {
          const item = items[j];
          if (!item.txt) continue;
          
          const itemX = item.item.transform[4];
          const itemY = item.item.transform[5];
          
          // Aynı satırda ve yakın mesafede mi?
          if (Math.abs(itemY - currentY) < 5 && Math.abs(itemX - currentX) < tolerance) {
            combined += item.txt.replace(/[!]/g, ''); // Ünlem işaretlerini temizle
            usedItems.push(item);
            currentX = itemX + (item.item.width || 10);
          }
        }
        
        // Aradığımız kelimeyi içeriyor mu?
        if (combined.includes(searchText)) {
          results.push({
            text: combined,
            items: usedItems,
            startItem: startItem
          });
        }
      }
      return results;
    };
    
    const yetkiliResults = findFragmentedText('YETKI');
    const imzasiResults = findFragmentedText('IMZASI');

    console.log(`🎯 YETKILI kelimesi bulunan sonuç sayısı: ${yetkiliResults.length}`);
    console.log(`🎯 IMZASI kelimesi bulunan sonuç sayısı: ${imzasiResults.length}`);
    
    if (yetkiliResults.length > 0) {
      console.log(`📝 Bulunan YETKILI metinleri: ${yetkiliResults.map(r => r.text).join(' | ')}`);
    }
    if (imzasiResults.length > 0) {
      console.log(`📝 Bulunan IMZASI metinleri: ${imzasiResults.map(r => r.text).join(' | ')}`);
    }

    for (const yResult of yetkiliResults) {
      const ytx = yResult.startItem.item.transform;
      const [yx, yy] = viewport.convertToViewportPoint(ytx[4], ytx[5]);

      // Aynı satırda (y koordinatı ±8px) ve yakın x'te bir IMZASI bul
      const pair = imzasiResults.find((iResult) => {
        const itx = iResult.startItem.item.transform;
        const [ix, iy] = viewport.convertToViewportPoint(itx[4], itx[5]);
        return Math.abs(iy - yy) < 12 && Math.abs(ix - yx) < 120; // esnek eşik
      });

      if (pair) {
        console.log(`🔍 Etiket ikilisi bulundu: "${yResult.text}" + "${pair.text}"`);
        const labelYTx = yResult.startItem.item.transform;
        const [vx, vy] = viewport.convertToViewportPoint(labelYTx[4], labelYTx[5]);

        // Metin bbox'ının altını bul (iki item'ın da alt sınırı)
        const bottomYLabel = vy + (yResult.startItem.item.height * viewport.scale); // metin yüksekliği eklenerek gerçek alt sınır
        const pairTx = pair.startItem.item.transform;
        const [pvx, pvy] = viewport.convertToViewportPoint(pairTx[4], pairTx[5]);
        const bottomYPair = pvy + (pair.startItem.item.height * viewport.scale);
        const bottomY = Math.max(bottomYLabel, bottomYPair);

        // Kutuyu bu alt sınırın hemen altından başlat (5px boşluk)
        const boxSize = 180; // Optimum kutu boyutu
        const srcX = Math.max(0, Math.min(canvas.width - boxSize, vx + 5)); // 5px sağa kaydır
        const srcY = Math.max(0, Math.min(canvas.height - boxSize, bottomY + 5)); // Yazının hemen altından başla

        console.log(`📍 Koordinatlar: vx=${vx.toFixed(1)}, vy=${vy.toFixed(1)}, bottomY=${bottomY.toFixed(1)}`);
        console.log(`📦 Kutu: srcX=${srcX}, srcY=${srcY}, boyut=${boxSize}x${boxSize}`);

        const sigCanvas = document.createElement('canvas');
        sigCanvas.width = boxSize;
        sigCanvas.height = boxSize;
        sigCanvas.getContext('2d').drawImage(canvas, srcX, srcY, boxSize, boxSize, 0, 0, boxSize, boxSize);

        // Yeni eklenen refine işlemi
        const refinedCanvas = refineBoundingBoxWithBorder(sigCanvas);

        const imgData = refinedCanvas.getContext('2d').getImageData(0, 0, refinedCanvas.width, refinedCanvas.height).data;
        let dark = 0;
        for (let i = 0; i < imgData.length; i += 4) {
          const brightness = (imgData[i] + imgData[i + 1] + imgData[i + 2]) / 3;
          if (brightness < 220) dark++;
        }
        console.log(`🖋️ Refine sonrası piksel analizi: dark=${dark}`);
        if (dark >= 100) {
          console.log('✅ Çerçeve tespit yöntemi ile imza yakalandı.');
          return refinedCanvas.toDataURL('image/png');
        } else {
          console.log('ℹ️ Refine yeterli koyu piksel sağlamadı, devam ediliyor.');
        }
      }
    }
    console.log('⚠️ Etiket ikilisi bulunamadı, universal yönteme geçiliyor...');
  } catch (err) {
    console.warn('⚠️ extractSignatureByLabel hatası:', err);
  }
  return null;
};

 